
// import { useState, useEffect, useContext } from "react";
// import MainLayouts from "../../../Layout/MainLayouts";

// import { ReactComponent as CheckSquareFill } from "bootstrap-icons/icons/check-square-fill.svg";
// import { ReactComponent as Eye } from "bootstrap-icons/icons/eye.svg";
// import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
// import { ReactComponent as XSquareFill } from "bootstrap-icons/icons/x-square-fill.svg";
// import { ReactComponent as CashStack } from "bootstrap-icons/icons/cash-stack.svg";
// import { ReactComponent as List } from "bootstrap-icons/icons/list.svg";
// import Spinner from "../../spinner/Spinner";
// import { Link, useNavigate } from "react-router-dom";
// import axios from "axios";
// import ApiServices from "../../../api/ApiServices";
// import { toast } from "react-toastify";
// import DataTable from "react-data-table-component";
// import Swal from "sweetalert2";
// import CustomStyles from "../../../components/utils/CustomStyles";
// import CurrencyFormatter from "../../../components/utils/CurrencyFormatter";
// import { handleError } from "../../../components/utils/AuthenticationCheck";
// import AxiosApiCall from "../../../api/AxiosApiCall";
// import { AuthContext } from "../../../AuthProvider/AuthProvider";
// // import CurrencyFormatter from "../../../components/utils/CurrencyFormatter";


// const ExpensesList = () => {
//   const [expense, setExpenses] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [filterText, setFilterText] = useState("");
//   const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
//   const [confirmationLoading, setConfirmationLoading] = useState(false);
//   const [perPage, setPerPage] = useState(20);
//   const [page, setPage] = useState(1);
//   const [total, setTotal] = useState(0);
//   const [selectedData, setSelectedData] = useState([]);

//   const { permissions } = useContext(AuthContext);
//   // console.log("this is all the perm", permissions);

//   const navigate = useNavigate();

//   //axios api encryption call
//   const axios = AxiosApiCall();

//   const fetchAllExpenses = async () => {
//     setLoading(true);
//     try {
//       const authData = JSON.parse(localStorage.getItem("auth"));
//       const token = authData?.token;
//       if (!token) {
//         throw new Error("No access token found.");
//       }
//       const response = await axios.get(ApiServices.getExpenseOpePending, {
//         headers: {
//           Authorization: `Bearer ${token}`,
//           "Content-Type": "application/json",
//         },
//         params: {
//           page: page,
//           per_page: perPage,
//         },
//         withCredentials: true,
//       });

//       const { status, message, data } = response.data;
//       // console.log("this is all expenses list", data);

//       if (status === 200) {
//         setExpenses(data.expenses);
//         setTotal(data.total);
//         setPerPage(data.per_page);
//         setPage(data.current_page);
//         toast.success(message, { toastId: "product-fetch-success" });
//       } else {
//         handleError({ response: { status, data: { message } } }, navigate);
//       }
//     } catch (error) {
//       handleError(error, navigate);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchAllExpenses();
//   }, [page, perPage]);

//   const handlePageChange = (newPage) => {
//     setPage(newPage);
//   };

//   const handlePerRowsChange = (newPerPage, newPage) => {
//     setPerPage(newPerPage);
//     setPage(newPage);
//   };

//   // approval
//   const handleExpenseApprova = async (data) => {
//     const { id: expenseId, amount, branch_info } = data;
//     const myaction = "approve";
//     const cleanAmount = parseFloat(amount.replace(/,/g, ''));

//     const { isConfirmed } = await Swal.fire({
//       title: "Approve Expense",
//       html: `
//         <input type="text" value="${branch_info.name}" 
//           class="w-full px-4 py-2 border border-gray-300 rounded-md mb-3 bg-gray-100 text-gray-700" readonly />
//         <input type="text" value="₦${cleanAmount.toLocaleString()}"
//           class="w-full px-4 py-2 border border-gray-300x rounded-md mb-3 bg-gray-100 text-gray-700" readonly />
//         <input type="hidden" value="${myaction}"
//           class="w-full px-4 py-2 border border-gray-300 rounded-md mb-3 bg-gray-100 text-gray-700" readonly />
//       `,
//       showCancelButton: true,
//       confirmButtonText: "Approve Expense",
//       customClass: {
//         confirmButton: "bg-dash text-lGrey hover:bg-dash focus:ring-2 focus:ring-dash", // red button
//         title: "text-dash",
//       },
//     });

//     if (isConfirmed) {
//       try {
//         setConfirmationLoading(true);
//         const authData = JSON.parse(localStorage.getItem("auth"));
//         const token = authData?.token;
//         if (!token) throw new Error("No access token found.");

//         const payload = {
//           expense_id: expenseId,
//           action: myaction,
//         };

//         const response = await axios.post(ApiServices.ExpenseOpeApproval, payload, {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//           withCredentials: true,
//         });

//         const { status, message } = response.data;
//         if (status === 200) {
//           toast.success(message, { toastId: "expense-approved-success" });
//           await fetchAllExpenses();
//         } else {
//           handleError({ response: { status, data: { message } } }, navigate);
//         }
//       } catch (error) {
//         handleError(error, navigate);
//       } finally {
//         setConfirmationLoading(false);
//       }
//     }
//   };
//   // rejecetion
//   const handleExpenseRejection = async (data) => {
//     const { id: expenseId, amount, branch_info } = data;
//     const myaction = "reject";
//     const cleanAmount = parseFloat(amount.replace(/,/g, ''));

//     const { value: formValues, isConfirmed } = await Swal.fire({
//       title: "Reject Expense",
//       html: `
//         <input type="text" value="${branch_info.name}" 
//           class="w-full px-4 py-2 border border-gray-300 rounded-md mb-3 bg-gray-100 text-gray-700" readonly />
//         <input type="text" value="₦${cleanAmount.toLocaleString()}"
//           class="w-full px-4 py-2 border border-gray-300 rounded-md mb-3 bg-gray-100 text-gray-700" readonly />
//         <textarea id="reason" placeholder="Enter your reason for rejection"
//           class="w-full px-4 py-2 border border-gray-300 rounded-md mb-1 resize-none h-24"></textarea>
//       `,
//       focusConfirm: false,
//       showCancelButton: true,
//       confirmButtonText: "Reject Expense",
//       customClass: {
//         confirmButton: "bg-dash3 text-lGrey hover:bg-dash3 focus:ring-2 focus:ring-dash3", // red button
//         title: "text-dash3",
//       },
//       preConfirm: () => {
//         const reason = document.getElementById("reason").value.trim();

//         if (!reason) {
//           Swal.showValidationMessage("Reason for rejection is required");
//           return;
//         }

//         return { reason };
//       },
//     });

//     if (isConfirmed && formValues) {
//       try {
//         setConfirmationLoading(true);
//         const authData = JSON.parse(localStorage.getItem("auth"));
//         const token = authData?.token;
//         if (!token) throw new Error("No access token found.");

//         const payload = {
//           expense_id: expenseId,
//           action: myaction,
//           rejection_reason: formValues.reason,
//         };

//         const response = await axios.post(ApiServices.RejectExpenseOpe, payload, {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//           withCredentials: true,
//         });

//         const { status, message } = response.data;
//         if (status === 200) {
//           toast.success(message, { toastId: "expense-rejected-success" });
//           await fetchAllExpenses();
//         } else {
//           handleError({ response: { status, data: { message } } }, navigate);
//         }
//       } catch (error) {
//         handleError(error, navigate);
//       } finally {
//         setConfirmationLoading(false);
//       }
//     }
//   };

//   //make payment
//   const handleExpensePay = async (data) => {
//     const { id: expenseId, amount, branch_info } = data;
//     const myaction = "pay";
//     const cleanAmount = parseFloat(amount.replace(/,/g, ''));

//     const { isConfirmed } = await Swal.fire({
//       title: "Pay Expense",
//       html: `
//       you are about to pay ${data.category} fee of amount  ₦${cleanAmount.toLocaleString()} for ${branch_info.name}
//       `,
//       showCancelButton: true,
//       confirmButtonText: "Make Payment",
//       customClass: {
//         confirmButton: "bg-dash5 text-lGrey hover:bg-dash5 focus:ring-2 focus:ring-dash5", // red button
//         title: "text-dash5",
//       },
//     });

//     if (isConfirmed) {
//       try {
//         setConfirmationLoading(true);
//         const authData = JSON.parse(localStorage.getItem("auth"));
//         const token = authData?.token;
//         if (!token) throw new Error("No access token found.");

//         const payload = {
//           expense_id: expenseId,
//           action: myaction,
//         };

//         const response = await axios.post(ApiServices.PaymentExpenseOpe, payload, {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//           withCredentials: true,
//         });

//         const { status, message } = response.data;
//         if (status === 200) {
//           toast.success(message, { toastId: "expense-approved-success" });
//           await fetchAllExpenses();
//         } else {
//           handleError({ response: { status, data: { message } } }, navigate);
//         }
//       } catch (error) {
//         handleError(error, navigate);
//       } finally {
//         setConfirmationLoading(false);
//       }
//     }
//   };

//   const handleChange = ({ selectedRows }) => {
//     setSelectedData(selectedRows);
//     // console.log("===========selected rows=========", selectedRows);
//   };

//   useEffect(() => {
//     // console.log("Selected Rows usestate: ", selectedData);
//   }, [selectedData]);

//   // bulk approval
//   const handleBulkApproval = async () => {
//     if (!selectedData || selectedData.length === 0) return;

//     const { isConfirmed } = await Swal.fire({
//       title: "<span style='color:#1D9E34'>Confirm Bulk Approval</span>",
//       html: `
//         <p>You are about to approve <strong>${selectedData.length}</strong> expenses.</p>
//         <p>This action cannot be undone.</p>
//       `,
//       icon: "info",
//       showCancelButton: true,
//       confirmButtonText: "Yes, Approve",
//       customClass: {
//         confirmButton: "bg-darkGreen3 text-lGrey hover:bg-darkGreen3 focus:ring-2 focus:ring-darkGreen3",
//         title: "text-dash5",
//       },
//       // cancelButtonText: "Cancel",
//       // confirmButtonColor: "#15803d", 
//       // cancelButtonColor: "#d1d5db",
//     });

//     if (isConfirmed) {
//       try {
//         setConfirmationLoading(true);
//         const authData = JSON.parse(localStorage.getItem("auth"));
//         const token = authData?.token;
//         if (!token) throw new Error("No access token found.");

//         const payload = {
//           expense_ids: selectedData.map((item) => item.id),
//           action: "approve",
//         };

//         const response = await axios.post(ApiServices.ExpenseOpeBulkApproval, payload, {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             "Content-Type": "application/json",
//           },
//           withCredentials: true,
//         });

//         const { status, message } = response.data;
//         if (status === 200) {
//           toast.success(message, { toastId: "bulk-approval-success" });
//           setSelectedData([]);
//           await fetchAllExpenses();
//         } else {
//           handleError({ response: { status, data: { message } } }, navigate);
//         }
//       } catch (error) {
//         handleError(error, navigate);
//       } finally {
//         setConfirmationLoading(false);
//       }
//     }
//   };

//   const handleFilter = (e) => {
//     setFilterText(e.target.value);
//     setResetPaginationToggle(!resetPaginationToggle);
//   };

//   // Define Expandable Component for Actions
//   const ExpandableComponent = ({ data }) => (
//     <div className="flex justify-start p-4 relative">
//       {permissions.some(permission => permission.name === 'branch.expense.view') && (
//         <div className="mx-2 my-2 group relative">
//           <Link
//             to="/operations/branch/expenses/show"
//             state={{ data }}
//           >
//             <Eye className="w-5 h-5 text-dash4 " />
//           </Link>
//           <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-1 hidden group-hover:block  text-darkGreen3 text-xs px-2 py-1 rounded">
//             Details
//           </div>
//         </div>
//       )}
//       {permissions.some(permission => permission.name === 'branch.expense.approve') && data.status === "pending" && (
//         <div className="mx-2 my-2 group relative">
//           <button
//             onClick={() => handleExpenseApprova(data)}
//             disabled={confirmationLoading}
//           >
//             <CheckSquareFill className="w-5 h-5 text-darkGreen3" />
//           </button>
//           <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-1 hidden group-hover:block text-dash4 text-xs px-2 py-1 rounded">
//             Approve
//           </div>
//         </div>
//       )}

//       {/* {
//         permissions.some(permission => permission.name === 'branch.expense.approve') && data.status === "approved" && (
//           <div className="mx-2 my-2 group relative">
//             <button
//               onClick={() => handleExpenseRejection(data)}
//               disabled={confirmationLoading}
//             >
//               <XSquareFill className="w-5 h-5 text-dash3 " />
//             </button>
//             <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-1 hidden group-hover:block text-dash text-xs px-2 py-1 rounded">
//               Reject
//             </div>
//           </div>
//         )
//       } */}
//       {/* {
//         permissions.some(permission => permission.name === 'branch.expense.pay') && (
//           <div className="mx-2 my-2 group relative">
//             <button
//               onClick={() => handleExpensePay(data)}
//               disabled={confirmationLoading}
//             >
//               <CashStack className="w-5 h-5 text-dash5 " />
//             </button>
//             <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-1 hidden group-hover:block text-dash5 text-xs px-2 py-1 rounded">
//               Pay
//             </div>
//           </div>
//         )
//       } */}
//     </div >
//   );


//   const columns = [
//     {
//       name: "Date",
//       selector: (row) =>
//         row.created_at ? new Date(row.created_at).toLocaleString() : "NOT AVAILABLE",
//       sortable: true,
//       width: "180px",
//     },
//     {
//       name: "Reference",
//       selector: (row) => (row.reference ? row.reference.toUpperCase() : "NOT AVAILABLE"),
//       sortable: true,
//       width: "200px",
//     },
//     {
//       name: "Category",
//       sortable: true,
//       width: "200px",
//       cell: (row) => (
//         <div>
//           <span className="block font-bold">
//             {row.category_name
//               ? row.category_name.toUpperCase()
//               : "NOT AVAILABLE"}
//           </span>
//           <span className="px-3 py-0.5 rounded-md bg-orange1 text-lGrey2 text-xs">
//             {row.branch_info.name
//               ? row.branch_info.name.toLowerCase()
//               : "NOT AVAILABLE"}
//           </span>
//         </div>
//       ),
//     },
//     {
//       name: "Amount",
//       selector: (row) => CurrencyFormatter(row.amount ? row.amount : "0.00"),
//       sortable: true,
//       width: "200px",
//     },

//     // {
//     //   name: "Status",
//     //   selector: (row) =>
//     //     row.status ? row.status.toUpperCase() : "NOT AVAILABLE",
//     //   sortable: true,
//     //   cell: (row) => {
//     //     const status = row.status?.toLowerCase();
//     //     let statusClass = "";

//     //     if (status === "pending") {
//     //       statusClass = "text-orange1";
//     //     } else if (status === "approved") {
//     //       statusClass = "text-dash";
//     //     } else if (status === "rejected") {
//     //       statusClass = "text-dash3";
//     //     } else {
//     //       statusClass = "text-dash5";
//     //     }

//     //     return (
//     //       <span className={statusClass}>
//     //         {row.status ? row.status.toUpperCase() : "NOT AVAILABLE"}
//     //       </span>
//     //     );
//     //   },
//     //   width: "100px",
//     // },

//     {
//       name: "Description",
//       selector: (row) => row.description ? row.description : "NOT AVAILABLE",
//       sortable: true,
//       width: "200px",
//     },
//   ];

//   const filteredItems = expense.filter((item) =>
//     Object.keys(item).some((key) =>
//       item[key]?.toString().toLowerCase().includes(filterText.toLowerCase())
//     )
//   );


//   const data = filteredItems.map((expense) => ({
//     reference: expense.reference || "NOT AVAILABLE",
//     category_name: expense.category_name,
//     amount: expense.amount || "NOT AVAILABLE",
//     base_price: expense.description,
//     status: expense.status,
//     created_at: expense.created_at,
//     description: expense.description,
//     branch_info: expense.branch_info,
//     id: expense.id,
//   }));

//   const sortedData = [...data].sort((a, b) => {
//     const dateA = new Date(a.created_at);
//     const dateB = new Date(b.created_at);
//     return dateB - dateA;
//   });


//   return (
//     <div>
//       <MainLayouts>
//         <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
//           <section className="w-full pr-[3%] pt-3 my-3" style={{ backgroundColor: "#F7F7F7" }}>
//             <nav className="bg-gray-200 py-0 px-4 rounded-lg">
//               <ol className="list-none p-0 inline-flex mb-2">
//                 <li className="flex items-center">
//                   <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
//                     Operations
//                   </p>
//                   <ChevronRightIcon />
//                 </li>
//                 <li className="flex items-center">
//                   <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
//                     Expenses
//                   </p>
//                   <ChevronRightIcon />
//                 </li>
//                 <li className="flex items-center">
//                   <p className="text-orange1">List</p>
//                 </li>
//               </ol>
//             </nav>
//           </section>
//           <div className="pb-4 bg-white dark:bg-gray-900 flex flex-wrap justify-between items-center">
//             <div className="relative w-full sm:w-1/2 mb-4 sm:mb-0">
//               <input
//                 type="search"
//                 className="block w-full px-3 py-2 text-md text-gray-900 border border-gray-300 rounded-lg bg-gray-50 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-lGrey"
//                 placeholder="Search"
//                 value={filterText}
//                 onChange={handleFilter}
//               />
//             </div>

//             <div className="flex space-x-2 sm:space-x-3 mt-2 sm:mt-0">
//               {permissions.some(permission => permission.name === 'branch.expense.approve') &&
//                 selectedData &&
//                 selectedData.length > 0 && (
//                   <button
//                     onClick={handleBulkApproval}
//                     className="text-dGrey3 bg-dash5 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center"
//                   >
//                     <span className="flex items-center">
//                       <CheckSquareFill className="mr-2" />
//                       Bulk Approval
//                     </span>
//                   </button>

//                 )}

//             </div>
//           </div>

//           {loading ? (
//             <Spinner />
//           ) : (
//             <DataTable
//               keyField="id"
//               columns={columns}
//               data={sortedData}
//               progressPending={loading}
//               pagination
//               paginationServer
//               paginationRowsPerPageOptions={[20]}
//               paginationTotalRows={total}
//               paginationDefaultPage={page}
//               paginationPerPage={perPage}
//               onChangePage={handlePageChange}
//               onChangeRowsPerPage={handlePerRowsChange}
//               highlightOnHover
//               striped
//               customStyles={CustomStyles}
//               noDataComponent={<div>No Expenses found</div>}
//               expandableRows
//               expandableRowsComponent={ExpandableComponent}
//               selectableRows
//               onSelectedRowsChange={handleChange}
//             />
//           )}
//         </div>
//       </MainLayouts>
//     </div>
//   );
// };

// export default ExpensesList;



import { useState, useEffect, useContext } from "react";
import MainLayouts from "../../../Layout/MainLayouts";
import { ReactComponent as CheckSquareFill } from "bootstrap-icons/icons/check-square-fill.svg";
import { ReactComponent as Eye } from "bootstrap-icons/icons/eye.svg";
import { ReactComponent as ChevronRightIcon } from "bootstrap-icons/icons/chevron-right.svg";
import { ReactComponent as ChevronDown } from "bootstrap-icons/icons/chevron-down.svg";
import { ReactComponent as Download } from "bootstrap-icons/icons/download.svg";
import { ReactComponent as Search } from "bootstrap-icons/icons/search.svg";
import { ReactComponent as XCircle } from "bootstrap-icons/icons/x-circle.svg";
import { ReactComponent as ArrowClockwise } from "bootstrap-icons/icons/arrow-clockwise.svg";
import Spinner from "../../spinner/Spinner";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import ApiServices from "../../../api/ApiServices";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";
import CustomStyles from "../../../components/utils/CustomStyles";
import CurrencyFormatter from "../../../components/utils/CurrencyFormatter";
import { handleError } from "../../../components/utils/AuthenticationCheck";
import AxiosApiCall from "../../../api/AxiosApiCall";
import { AuthContext } from "../../../AuthProvider/AuthProvider";
import { downloadCSVFromApi } from "../../../components/utils/DownlaodCSVFromApi";
import formatDate from "../../../components/utils/DateFormatter";

const ExpensesList = () => {
  const [expense, setExpenses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingCSV, setLoadingCSV] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [confirmationLoading, setConfirmationLoading] = useState(false);
  const [perPage, setPerPage] = useState(20);
  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [selectedData, setSelectedData] = useState([]);
  const [selectedExpenseType, setSelectedExpenseType] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  // Date filter state
  const [filters, setFilters] = useState({
    start_date: "",
    end_date: "",
  });

  const { permissions } = useContext(AuthContext);
  const navigate = useNavigate();
  const axios = AxiosApiCall();

  const fetchAllExpenses = async () => {
    setLoading(true);
    try {
      const authData = JSON.parse(localStorage.getItem("auth"));
      const token = authData?.token;
      if (!token) {
        throw new Error("No access token found.");
      }
      const response = await axios.get(ApiServices.getExpenseOpePending, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        params: {
          page: page,
          per_page: perPage,
        },
        withCredentials: true,
      });

      const { status, message, data } = response.data;

      if (status === 200) {
        setExpenses(data.expenses);
        setTotal(data.total);
        setPerPage(data.per_page);
        setPage(data.current_page);
        toast.success(message, { toastId: "product-fetch-success" });
      } else {
        handleError({ response: { status, data: { message } } }, navigate);
      }
    } catch (error) {
      handleError(error, navigate);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllExpenses();
  }, [page, perPage]);

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handlePerRowsChange = (newPerPage, newPage) => {
    setPerPage(newPerPage);
    setPage(newPage);
  };

  // Handle filter changes
  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };

  // Check if both dates are selected
  const areDatesSelected = filters.start_date && filters.end_date;

  //filter data by name
  const handleFilter = (e) => {
    setFilterText(e.target.value);
    setResetPaginationToggle(!resetPaginationToggle);
  };

  //select expense type
  const handleExpenseTypeSelect = (type) => {
    setSelectedExpenseType(type);
    setIsDropdownOpen(false);
  };

  // approval
  const handleExpenseApprova = async (data) => {
    const { id: expenseId, amount, branch_info } = data;
    const myaction = "approve";
    const cleanAmount = parseFloat(amount.replace(/,/g, ''));

    const { isConfirmed } = await Swal.fire({
      title: "Approve Expense",
      html: `
        <input type="text" value="${branch_info.name}" 
          class="w-full px-4 py-2 border border-gray-300 rounded-md mb-3 bg-gray-100 text-gray-700" readonly />
        <input type="text" value="₦${cleanAmount.toLocaleString()}"
          class="w-full px-4 py-2 border border-gray-300x rounded-md mb-3 bg-gray-100 text-gray-700" readonly />
        <input type="hidden" value="${myaction}"
          class="w-full px-4 py-2 border border-gray-300 rounded-md mb-3 bg-gray-100 text-gray-700" readonly />
      `,
      showCancelButton: true,
      confirmButtonText: "Approve Expense",
      customClass: {
        confirmButton: "bg-dash text-lGrey hover:bg-dash focus:ring-2 focus:ring-dash",
        title: "text-dash",
      },
    });

    if (isConfirmed) {
      try {
        setConfirmationLoading(true);
        const authData = JSON.parse(localStorage.getItem("auth"));
        const token = authData?.token;
        if (!token) throw new Error("No access token found.");

        const payload = {
          expense_id: expenseId,
          action: myaction,
        };

        const response = await axios.post(ApiServices.ExpenseOpeApproval, payload, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          withCredentials: true,
        });

        const { status, message } = response.data;
        if (status === 200) {
          toast.success(message, { toastId: "expense-approved-success" });
          await fetchAllExpenses();
        } else {
          handleError({ response: { status, data: { message } } }, navigate);
        }
      } catch (error) {
        handleError(error, navigate);
      } finally {
        setConfirmationLoading(false);
      }
    }
  };

  // rejecetion
  const handleExpenseRejection = async (data) => {
    const { id: expenseId, amount, branch_info } = data;
    const myaction = "reject";
    const cleanAmount = parseFloat(amount.replace(/,/g, ''));

    const { value: formValues, isConfirmed } = await Swal.fire({
      title: "Reject Expense",
      html: `
        <input type="text" value="${branch_info.name}" 
          class="w-full px-4 py-2 border border-gray-300 rounded-md mb-3 bg-gray-100 text-gray-700" readonly />
        <input type="text" value="₦${cleanAmount.toLocaleString()}"
          class="w-full px-4 py-2 border border-gray-300 rounded-md mb-3 bg-gray-100 text-gray-700" readonly />
        <textarea id="reason" placeholder="Enter your reason for rejection"
          class="w-full px-4 py-2 border border-gray-300 rounded-md mb-1 resize-none h-24"></textarea>
      `,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: "Reject Expense",
      customClass: {
        confirmButton: "bg-dash3 text-lGrey hover:bg-dash3 focus:ring-2 focus:ring-dash3",
        title: "text-dash3",
      },
      preConfirm: () => {
        const reason = document.getElementById("reason").value.trim();

        if (!reason) {
          Swal.showValidationMessage("Reason for rejection is required");
          return;
        }

        return { reason };
      },
    });

    if (isConfirmed && formValues) {
      try {
        setConfirmationLoading(true);
        const authData = JSON.parse(localStorage.getItem("auth"));
        const token = authData?.token;
        if (!token) throw new Error("No access token found.");

        const payload = {
          expense_id: expenseId,
          action: myaction,
          rejection_reason: formValues.reason,
        };

        const response = await axios.post(ApiServices.RejectExpenseOpe, payload, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          withCredentials: true,
        });

        const { status, message } = response.data;
        if (status === 200) {
          toast.success(message, { toastId: "expense-rejected-success" });
          await fetchAllExpenses();
        } else {
          handleError({ response: { status, data: { message } } }, navigate);
        }
      } catch (error) {
        handleError(error, navigate);
      } finally {
        setConfirmationLoading(false);
      }
    }
  };

  //make payment
  const handleExpensePay = async (data) => {
    const { id: expenseId, amount, branch_info } = data;
    const myaction = "pay";
    const cleanAmount = parseFloat(amount.replace(/,/g, ''));

    const { isConfirmed } = await Swal.fire({
      title: "Pay Expense",
      html: `
      you are about to pay ${data.category} fee of amount  ₦${cleanAmount.toLocaleString()} for ${branch_info.name}
      `,
      showCancelButton: true,
      confirmButtonText: "Make Payment",
      customClass: {
        confirmButton: "bg-dash5 text-lGrey hover:bg-dash5 focus:ring-2 focus:ring-dash5",
        title: "text-dash5",
      },
    });

    if (isConfirmed) {
      try {
        setConfirmationLoading(true);
        const authData = JSON.parse(localStorage.getItem("auth"));
        const token = authData?.token;
        if (!token) throw new Error("No access token found.");

        const payload = {
          expense_id: expenseId,
          action: myaction,
        };

        const response = await axios.post(ApiServices.PaymentExpenseOpe, payload, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          withCredentials: true,
        });

        const { status, message } = response.data;
        if (status === 200) {
          toast.success(message, { toastId: "expense-approved-success" });
          await fetchAllExpenses();
        } else {
          handleError({ response: { status, data: { message } } }, navigate);
        }
      } catch (error) {
        handleError(error, navigate);
      } finally {
        setConfirmationLoading(false);
      }
    }
  };

  const handleChange = ({ selectedRows }) => {
    setSelectedData(selectedRows);
  };

  // bulk approval
  const handleBulkApproval = async () => {
    if (!selectedData || selectedData.length === 0) return;

    const { isConfirmed } = await Swal.fire({
      title: "<span style='color:#1D9E34'>Confirm Bulk Approval</span>",
      html: `
        <p>You are about to approve <strong>${selectedData.length}</strong> expenses.</p>
        <p>This action cannot be undone.</p>
      `,
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Yes, Approve",
      customClass: {
        confirmButton: "bg-darkGreen3 text-lGrey hover:bg-darkGreen3 focus:ring-2 focus:ring-darkGreen3",
        title: "text-dash5",
      },
    });

    if (isConfirmed) {
      try {
        setConfirmationLoading(true);
        const authData = JSON.parse(localStorage.getItem("auth"));
        const token = authData?.token;
        if (!token) throw new Error("No access token found.");

        const payload = {
          expense_ids: selectedData.map((item) => item.id),
          action: "approve",
        };

        const response = await axios.post(ApiServices.ExpenseOpeBulkApproval, payload, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          withCredentials: true,
        });

        const { status, message } = response.data;
        if (status === 200) {
          toast.success(message, { toastId: "bulk-approval-success" });
          setSelectedData([]);
          await fetchAllExpenses();
        } else {
          handleError({ response: { status, data: { message } } }, navigate);
        }
      } catch (error) {
        handleError(error, navigate);
      } finally {
        setConfirmationLoading(false);
      }
    }
  };

  // Handle CSV Download - Server-side filtered by date
  const handleDownloadCSV = async () => {
    if (!areDatesSelected) {
      toast.error("Please select both start and end dates to download CSV");
      return;
    }

    // Validate date range
    const startDate = new Date(filters.start_date);
    const endDate = new Date(filters.end_date);

    if (startDate > endDate) {
      toast.error("Start date must be before end date");
      return;
    }

    // limit date range to a year
    const daysDiff = Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24));
    if (daysDiff > 365) {
      toast.error("Date range cannot exceed 1 year");
      return;
    }

    setLoadingCSV(true);

    try {
      const authData = JSON.parse(localStorage.getItem("auth"));
      const token = authData?.token;

      if (!token) {
        toast.error("No access token found");
        return;
      }

      // Prepare download payload with status filter
      // const downloadPayload = {
      //   start_date: filters.start_date,
      //   end_date: filters.end_date,
      //   download: 1,
      //   // status: selectedExpenseType || "all" // Add status filter if selected
      // };

      const downloadPayload = {
        start_date: filters.start_date,
        end_date: filters.end_date,
        download: 1,
      };

      // console.log("Download Payload:", downloadPayload);

      // Create filename with date range and type
      // const startDateFormatted = filters.start_date.replace(/-/g, '_');
      // const endDateFormatted = filters.end_date.replace(/-/g, '_');
      // // const typeSuffix = selectedExpenseType ? `_${selectedExpenseType}` : '';
      // // const filename = `expenses_${startDateFormatted}_to_${endDateFormatted}${typeSuffix}.csv`;
      // const filename = `expenses_${startDateFormatted}_to_${endDateFormatted}.csv`;



      const startDateFormatted = filters.start_date.replace(/-/g, '_');
      const endDateFormatted = filters.end_date.replace(/-/g, '_');
      const filename = `expenses_${startDateFormatted}_to_${endDateFormatted}.csv`;

      await downloadCSVFromApi(
        ApiServices.getExpenseOpePending,
        downloadPayload,
        token,
        {
          filename: filename,
          columnsToRemove: [], // Add sensitive columns to exclude 
          maxRows: 50000
        }
      );

    } catch (error) {
      // console.error("Download error:", error);
      handleError(error, navigate);
      // Additional download-specific error messages
      if (error.message && error.message.includes("CSV")) {
        toast.error("Failed to process CSV file");
      } else if (error.message && error.message.includes("network")) {
        toast.error("Network error during download");
      }
    } finally {
      setLoadingCSV(false);
    }
  };

  // Clear date filters
  const handleClearDates = () => {
    setFilters({
      start_date: "",
      end_date: "",
    });
    toast.success("Date filters cleared");
  };

  // Clear expense type filter
  const handleClearExpenseType = () => {
    setSelectedExpenseType("");
    toast.success("Expense type filter cleared");
  };

  // Define Expandable Component for Actions
  const ExpandableComponent = ({ data }) => (
    <div className="flex justify-start p-4 relative">
      {permissions.some(permission => permission.name === 'branch.expense.view') && (
        <div className="mx-2 my-2 group relative">
          <Link
            to="/operations/branch/expenses/show"
            state={{ data }}
          >
            <Eye className="w-5 h-5 text-dash4 " />
          </Link>
          <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-1 hidden group-hover:block  text-darkGreen3 text-xs px-2 py-1 rounded">
            Details
          </div>
        </div>
      )}
      {permissions.some(permission => permission.name === 'branch.expense.approve') && data.status === "pending" && (
        <div className="mx-2 my-2 group relative">
          <button
            onClick={() => handleExpenseApprova(data)}
            disabled={confirmationLoading}
          >
            <CheckSquareFill className="w-5 h-5 text-darkGreen3" />
          </button>
          <div className="absolute top-full left-1/2 transform -translate-x-1/2 mt-1 hidden group-hover:block text-dash4 text-xs px-2 py-1 rounded">
            Approve
          </div>
        </div>
      )}
    </div>
  );

  const columns = [
    {
      name: "Date",
      selector: (row) =>
        // row.created_at ? new Date(row.created_at).toLocaleString() : "NOT AVAILABLE",
        row.created_at ? formatDate(row.created_at) : "NOT AVAILABLE",
      sortable: true,
      width: "180px",
    },
    {
      name: "Reference",
      selector: (row) => (row.reference ? row.reference.toUpperCase() : "NOT AVAILABLE"),
      sortable: true,
      width: "200px",
    },
    {
      name: "Category",
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div>
          <span className="block font-bold">
            {row.category_name
              ? row.category_name.toUpperCase()
              : "NOT AVAILABLE"}
          </span>
          <span className="px-3 py-0.5 rounded-md bg-orange1 text-lGrey2 text-xs">
            {row.branch_info.name
              ? row.branch_info.name.toLowerCase()
              : "NOT AVAILABLE"}
          </span>
        </div>
      ),
    },
    {
      name: "Amount",
      selector: (row) => CurrencyFormatter(row.amount ? row.amount : "0.00"),
      sortable: true,
      width: "200px",
    },
    {
      name: "Status",
      selector: (row) =>
        row.status ? row.status.toUpperCase() : "NOT AVAILABLE",
      sortable: true,
      cell: (row) => {
        const status = row.status?.toLowerCase();
        let statusClass = "";

        if (status === "pending") {
          statusClass = "text-orange1";
        } else if (status === "approved") {
          statusClass = "text-dash";
        } else if (status === "rejected") {
          statusClass = "text-dash3";
        } else if (status === "paid") {
          statusClass = "text-dash5";
        } else {
          statusClass = "text-black2";
        }

        return (
          <span className={statusClass}>
            {row.status ? row.status.toUpperCase() : "NOT AVAILABLE"}
          </span>
        );
      },
      width: "100px",
    },
    {
      name: "Description",
      selector: (row) => row.description ? row.description : "NOT AVAILABLE",
      sortable: true,
      width: "200px",
    },
  ];

  // Filter data based on search text, expense type, AND date range
  const filteredItems = expense.filter((item) => {
    const matchesFilterText = Object.values(item).some(
      (value) =>
        typeof value === "string" &&
        value.toLowerCase().includes(filterText.toLowerCase())
    );

    // Filter data based on selected expense type (status)
    const matchesExpenseType =
      !selectedExpenseType ||
      item.status.toLowerCase() === selectedExpenseType.toLowerCase();

    // Filter data based on date range
    let matchesDateRange = true;
    if (areDatesSelected) {
      const itemDate = new Date(item.created_at);
      const startDate = new Date(filters.start_date);
      const endDate = new Date(filters.end_date);

      // Set time to end of day for end date
      endDate.setHours(23, 59, 59, 999);

      matchesDateRange = itemDate >= startDate && itemDate <= endDate;
    }

    return matchesFilterText && matchesExpenseType && matchesDateRange;
  });

  const data = filteredItems.map((expense) => ({
    reference: expense.reference || "NOT AVAILABLE",
    category_name: expense.category_name,
    amount: expense.amount || "NOT AVAILABLE",
    base_price: expense.description,
    status: expense.status,
    created_at: expense.created_at,
    description: expense.description,
    branch_info: expense.branch_info,
    id: expense.id,
  }));

  const sortedData = [...data].sort((a, b) => {
    const dateA = new Date(a.created_at);
    const dateB = new Date(b.created_at);
    return dateB - dateA;
  });

  return (
    <div>
      <MainLayouts>
        <div className="relative overflow-x-auto sm:rounded-lg py-6 w-full">
          <section className="w-full pr-[3%] pt-3 my-3" style={{ backgroundColor: "#F7F7F7" }}>
            <nav className="bg-gray-200 py-0 px-4 rounded-lg">
              <ol className="list-none p-0 inline-flex mb-2">
                <li className="flex items-center">
                  <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                    Operations
                  </p>
                  <ChevronRightIcon />
                </li>
                <li className="flex items-center">
                  <p className="text-blue-500 hover:text-blue-600 text-darkGreen3 pr-2">
                    Expenses
                  </p>
                  <ChevronRightIcon />
                </li>
                <li className="flex items-center">
                  <p className="text-orange1">List</p>
                </li>
              </ol>
            </nav>
          </section>

          {/* Filter Controls Section - Responsive */}
          <div className="pb-4 bg-white dark:bg-gray-900">
            {/* DESKTOP FILTERS (md and up) - All in one row */}
            <div className="hidden md:flex flex-wrap items-center gap-3">
              {/* Search Input Field with Icon */}
              <div className="relative flex-grow min-w-[200px]">
                <div className="relative">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
                  <input
                    type="search"
                    className="block w-full pl-10 pr-3 py-2 text-md text-black1 border border-gray-300 rounded-lg bg-gray-50 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-black1"
                    placeholder="Search ..."
                    value={filterText}
                    onChange={handleFilter}
                  />
                </div>
              </div>

              {/* Expense Type Dropdown */}
              <div className="relative min-w-[180px]">
                <div>
                  {permissions.some(permission => permission.name === 'branch.expense.view') && (
                    <button
                      type="button"
                      className="bg-darkGreen3 inline-flex w-full justify-between items-center rounded-md px-3 py-2.5 text-sm font-semibold text-dGrey3"
                      id="menu-button"
                      aria-expanded={isDropdownOpen}
                      aria-haspopup="true"
                      onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                    >
                      <span className="truncate">
                        {selectedExpenseType || "Status Type"}
                      </span>
                      <ChevronDown className="w-4 h-4 text-gray-400" />
                    </button>
                  )}
                </div>
                {isDropdownOpen && (
                  <div
                    className="absolute right-0 z-10 mt-1 w-full origin-top-right divide-y divide-gray-100 rounded-md bg-lGrey shadow-lg ring-1 ring-black1 ring-opacity-5 focus:outline-none"
                    role="menu"
                    aria-orientation="vertical"
                    aria-labelledby="menu-button"
                  >
                    <div
                      className="py-1 rounded-md"
                      role="none"
                      style={{ backgroundColor: "white" }}
                    >
                      <button
                        onClick={() => handleExpenseTypeSelect("pending")}
                        className="block w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-darkGreen3 text-left"
                        role="menuitem"
                      >
                        Pending
                      </button>
                      <button
                        onClick={() => handleExpenseTypeSelect("approved")}
                        className="block w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-darkGreen3 text-left"
                        role="menuitem"
                      >
                        Approved
                      </button>
                      <button
                        onClick={() => handleExpenseTypeSelect("rejected")}
                        className="block w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-darkGreen3 text-left"
                        role="menuitem"
                      >
                        Rejected
                      </button>
                      <button
                        onClick={() => handleExpenseTypeSelect("paid")}
                        className="block w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-darkGreen3 text-left"
                        role="menuitem"
                      >
                        Paid
                      </button>
                      <button
                        type="button"
                        className="block w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-darkGreen3 text-left"
                        onClick={() => handleExpenseTypeSelect("")}
                      >
                        All Status
                      </button>
                    </div>
                  </div>
                )}
              </div>

              {/* Start Date Input */}
              <div className="min-w-[150px]">
                <div className="relative">
                  <input
                    type="date"
                    value={filters.start_date}
                    onChange={(e) => handleFilterChange("start_date", e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:ring-2 focus:ring-orange1 focus:border-transparent"
                    max={filters.end_date || undefined}
                    placeholder="Start Date"
                  />
                </div>
              </div>

              {/* End Date Input */}
              <div className="min-w-[150px]">
                <div className="relative">
                  <input
                    type="date"
                    value={filters.end_date}
                    onChange={(e) => handleFilterChange("end_date", e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50 focus:ring-2 focus:ring-orange1 focus:border-transparent"
                    min={filters.start_date || undefined}
                    placeholder="End Date"
                  />
                </div>
              </div>

              {/* Clear Dates Button - Only show when dates are selected */}
              {areDatesSelected && (
                <div className="min-w-[120px]">
                  <button
                    onClick={handleClearDates}
                    className="w-full inline-flex justify-center items-center gap-x-2 px-4 py-2.5 text-sm font-medium text-lGrey bg-black1 rounded-lg hover:bg-gray-800 transition-colors duration-200"
                  >
                    <XCircle className="w-4 h-4" />
                    Clear Dates
                  </button>
                </div>
              )}

              {/* Clear Expense Type Button - Only show when type is selected */}
              {selectedExpenseType && (
                <div className="min-w-[120px]">
                  <button
                    onClick={handleClearExpenseType}
                    className="w-full inline-flex justify-center items-center gap-x-2 px-4 py-2.5 text-sm font-medium text-lGrey bg-gray-600 rounded-lg hover:bg-gray-700 transition-colors duration-200"
                  >
                    <XCircle className="w-4 h-4" />
                    Clear Status
                  </button>
                </div>
              )}

              {/* Download Button */}
              <div className="min-w-[160px]">
                <button
                  onClick={handleDownloadCSV}
                  className={`w-full inline-flex justify-center items-center gap-x-2 rounded-md px-4 py-2.5 text-sm font-semibold transition-colors duration-200 ${areDatesSelected
                    ? "bg-orange1 text-lGrey hover:bg-blue-600 cursor-pointer"
                    : "bg-gray-300 text-gray-500 cursor-not-allowed"
                    }`}
                  disabled={!areDatesSelected || loadingCSV}
                  title={!areDatesSelected ? "Select start and end dates to enable download" : ""}
                >
                  {loadingCSV ? (
                    <>
                      <ArrowClockwise className="w-4 h-4 text-lGrey animate-spin" />
                      Downloading...
                    </>
                  ) : (
                    <>
                      <Download className="w-4 h-4" />
                      Download CSV
                    </>
                  )}
                </button>
              </div>

              {/* Bulk Approval Button */}
              {permissions.some(permission => permission.name === 'branch.expense.approve') &&
                selectedData &&
                selectedData.length > 0 && (
                  <div className="min-w-[160px]">
                    <button
                      onClick={handleBulkApproval}
                      disabled={confirmationLoading}
                      className="w-full text-dGrey3 bg-dash5 hover:bg-red-600 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center flex items-center justify-center"
                    >
                      <span className="flex items-center">
                        <CheckSquareFill className="mr-2" />
                        Bulk Approval ({selectedData.length})
                      </span>
                    </button>
                  </div>
                )}
            </div>

            {/* MOBILE FILTERS (below md) - Stacked layout */}
            <div className="md:hidden flex flex-col gap-3">
              {/* Search - Full width on mobile */}
              <div className="w-full">
                <div className="relative">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
                  <input
                    type="search"
                    className="block w-full pl-10 pr-3 py-3 text-md text-black1 border border-gray-300 rounded-lg bg-gray-50"
                    placeholder="Search expenses..."
                    value={filterText}
                    onChange={handleFilter}
                  />
                </div>
              </div>

              {/* Filters grid for mobile */}
              <div className="grid grid-cols-2 gap-3">
                {/* Expense Type Dropdown - Full width on mobile */}
                <div className="col-span-2">
                  <div>
                    {permissions.some(permission => permission.name === 'branch.expense.view') && (
                      <button
                        type="button"
                        className="bg-darkGreen3 inline-flex w-full justify-between items-center rounded-md px-4 py-3 text-sm font-semibold text-dGrey3"
                        id="mobile-menu-button"
                        aria-expanded={isDropdownOpen}
                        aria-haspopup="true"
                        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                      >
                        <span className="truncate">
                          {selectedExpenseType || "Status Type"}
                        </span>
                        <ChevronDown className="w-4 h-4 text-gray-400" />
                      </button>
                    )}
                  </div>
                  {isDropdownOpen && (
                    <div
                      className="relative z-10 mt-1 w-full divide-y divide-gray-100 rounded-md bg-lGrey shadow-lg ring-1 ring-black1 ring-opacity-5 focus:outline-none"
                      role="menu"
                      aria-orientation="vertical"
                      aria-labelledby="mobile-menu-button"
                    >
                      <div
                        className="py-1 rounded-md"
                        role="none"
                        style={{ backgroundColor: "white" }}
                      >
                        <button
                          onClick={() => handleExpenseTypeSelect("pending")}
                          className="block w-full px-4 py-3 text-sm text-gray-700 hover:bg-gray-100 hover:text-darkGreen3 text-left"
                          role="menuitem"
                        >
                          Pending
                        </button>
                        <button
                          onClick={() => handleExpenseTypeSelect("approved")}
                          className="block w-full px-4 py-3 text-sm text-gray-700 hover:bg-gray-100 hover:text-darkGreen3 text-left"
                          role="menuitem"
                        >
                          Approved
                        </button>
                        <button
                          onClick={() => handleExpenseTypeSelect("rejected")}
                          className="block w-full px-4 py-3 text-sm text-gray-700 hover:bg-gray-100 hover:text-darkGreen3 text-left"
                          role="menuitem"
                        >
                          Rejected
                        </button>
                        <button
                          onClick={() => handleExpenseTypeSelect("paid")}
                          className="block w-full px-4 py-3 text-sm text-gray-700 hover:bg-gray-100 hover:text-darkGreen3 text-left"
                          role="menuitem"
                        >
                          Paid
                        </button>
                        <button
                          type="button"
                          className="block w-full px-4 py-3 text-sm text-gray-700 hover:bg-gray-100 hover:text-darkGreen3 text-left"
                          onClick={() => handleExpenseTypeSelect("")}
                        >
                          All Status
                        </button>
                      </div>
                    </div>
                  )}
                </div>

                {/* Start Date - Half width on mobile */}
                <div className="col-span-1">
                  <div className="relative">
                    <input
                      type="date"
                      value={filters.start_date}
                      onChange={(e) => handleFilterChange("start_date", e.target.value)}
                      className="w-full px-3 py-3 border border-gray-300 rounded-lg bg-gray-50"
                      max={filters.end_date || undefined}
                      placeholder="Start"
                    />
                  </div>
                </div>

                {/* End Date - Half width on mobile */}
                <div className="col-span-1">
                  <div className="relative">
                    <input
                      type="date"
                      value={filters.end_date}
                      onChange={(e) => handleFilterChange("end_date", e.target.value)}
                      className="w-full px-3 py-3 border border-gray-300 rounded-lg bg-gray-50"
                      min={filters.start_date || undefined}
                      placeholder="End"
                    />
                  </div>
                </div>

                {/* Clear Dates Button - Full width when shown */}
                {areDatesSelected && (
                  <div className="col-span-2">
                    <button
                      onClick={handleClearDates}
                      className="w-full inline-flex justify-center items-center gap-x-2 px-4 py-3 text-sm font-medium text-lGrey bg-black1 rounded-lg hover:bg-gray-800"
                    >
                      <XCircle className="w-4 h-4" />
                      Clear Dates
                    </button>
                  </div>
                )}

                {/* Clear Expense Type Button - Full width when shown */}
                {selectedExpenseType && (
                  <div className="col-span-2">
                    <button
                      onClick={handleClearExpenseType}
                      className="w-full inline-flex justify-center items-center gap-x-2 px-4 py-3 text-sm font-medium text-lGrey bg-gray-600 rounded-lg hover:bg-gray-700"
                    >
                      <XCircle className="w-4 h-4" />
                      Clear Status
                    </button>
                  </div>
                )}

                {/* Download Button - Full width on mobile */}
                <div className="col-span-2">
                  <button
                    onClick={handleDownloadCSV}
                    className={`w-full inline-flex justify-center items-center gap-x-2 rounded-md px-4 py-3 text-sm font-semibold ${areDatesSelected
                      ? "bg-orange1 text-lGrey hover:bg-blue-600"
                      : "bg-gray-300 text-gray-500 cursor-not-allowed"
                      }`}
                    disabled={!areDatesSelected || loadingCSV}
                  >
                    {loadingCSV ? (
                      <>
                        <ArrowClockwise className="w-4 h-4 text-lGrey animate-spin" />
                        <span className="ml-2">Downloading...</span>
                      </>
                    ) : (
                      <>
                        <Download className="w-4 h-4" />
                        <span className="ml-2">Download CSV</span>
                      </>
                    )}
                  </button>
                </div>

                {/* Bulk Approval Button - Full width on mobile */}
                {permissions.some(permission => permission.name === 'branch.expense.approve') &&
                  selectedData &&
                  selectedData.length > 0 && (
                    <div className="col-span-2">
                      <button
                        onClick={handleBulkApproval}
                        disabled={confirmationLoading}
                        className="w-full text-dGrey3 bg-dash5 hover:bg-red-600 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-3 text-center flex items-center justify-center"
                      >
                        <span className="flex items-center">
                          <CheckSquareFill className="mr-2" />
                          Bulk Approval ({selectedData.length})
                        </span>
                      </button>
                    </div>
                  )}
              </div>
            </div>

            {/* DESKTOP help text (md and up) */}
            <div className="hidden md:flex items-center justify-between mt-2">
              {!areDatesSelected && (
                <p className="text-xs text-gray-500">
                  Select start and end dates to enable download
                </p>
              )}
              {areDatesSelected && sortedData.length > 0 && (
                <p className="text-sm text-gray-600">
                  Showing {sortedData.length} expenses from {filters.start_date} to {filters.end_date}
                  {selectedExpenseType && ` (Status: ${selectedExpenseType})`}
                </p>
              )}
            </div>

            {/* MOBILE help text (below md) */}
            <div className="md:hidden mt-3">
              {!areDatesSelected && (
                <p className="text-xs text-gray-500 text-center mb-2">
                  Select start and end dates to enable download
                </p>
              )}
              {areDatesSelected && sortedData.length > 0 && (
                <p className="text-sm text-gray-600 text-center">
                  Showing {sortedData.length} expenses
                  {selectedExpenseType && ` (${selectedExpenseType})`}
                </p>
              )}
            </div>
          </div>

          {/* Data Table */}
          {loading ? (
            <Spinner />
          ) : (
            <DataTable
              keyField="id"
              columns={columns}
              data={sortedData}
              progressPending={loading}
              pagination
              paginationServer
              paginationRowsPerPageOptions={[20]}
              paginationTotalRows={total}
              paginationDefaultPage={page}
              paginationPerPage={perPage}
              onChangePage={handlePageChange}
              onChangeRowsPerPage={handlePerRowsChange}
              highlightOnHover
              striped
              customStyles={CustomStyles}
              noDataComponent={
                <div className="text-center py-8">
                  {areDatesSelected ?
                    "No expenses found for the selected date range" :
                    "No expenses found"
                  }
                </div>
              }
              expandableRows
              expandableRowsComponent={ExpandableComponent}
              selectableRows
              onSelectedRowsChange={handleChange}
            />
          )}
        </div>
      </MainLayouts>
    </div>
  );
};

export default ExpensesList;



